import React, { Component } from "react";
import Translation from "../../../../common/translation/translation.component";
import { MODAL_CUSTOM_MESSAGE, TABLE_PAGINATION_KEY } from "../../../../../constants/external-constants";
import { DetailsDashboard } from "../../../../common/details-dashboard/details-dashboard-layout";
import { TablePagination } from "../../../../common/details-table/table-pagination.component";
import { RequestHeaders } from "../../../../common/header-logo/request-header.component";
import { NoSubscription } from "../../../dashboard/no-subscription/no-subscription.component";
import ModalContainer from "../../../../common/modal/modal-container/modal-container.component";
import OutputRecordsInfo from "../modal/output-records-info.component";
import { bindActionCreators } from "@reduxjs/toolkit";
import { OutputRecordAction } from "../../../../../store/external/recharge-reducer/output-record.reducer/output-record.reducer";
import { connect } from "react-redux";

import { validateAccessModule } from "../../../../../utils/helpers.utils";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../../utils/rbac-constants.utils";
class OutputRecordsDashboard extends Component {
    constructor(props) {
        super(props);
        this.displaySearchBox = this.displaySearchBox.bind(this)
        this.state = {
            displaySearch: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            showModal: false,
            showModalForm: false,
            modalTitle: '',
            headerTitle: "OutputRecords",
            selectedRecordData: null,
            isLoading: false,
            modalIsLoading: false
        }
    }

    onClickExtract = (e) => {
        const {extractOutputRecord}=this.props
        if (window.confirm(this.state.exportAlertMsg)) {
            extractOutputRecord()
        }
    };

    componentDidMount() {
        const {fetchOutputRecord}=this.props;
        this.setState({isLoading:true})
        fetchOutputRecord().then(()=>{
            this.setState({isLoading:false})
        })
    }

    displaySearchBox() {
        this.setState({ displaySearch: !this.state.displaySearch })
    }

    resizePage = (value) => {
        const {resizePageSize, fetchOutputRecord}=this.props;
        resizePageSize(value)
        fetchOutputRecord()
    }

    loading = () => {
        return (
            <NoSubscription />
        );
    }

    applyFilter = (isApply) => {
        const { fetchOutputRecord, applyOutputRecordFilter } = this.props;
        applyOutputRecordFilter(isApply);
        fetchOutputRecord();
    }

    handleRowClick = async (data) => {
        const { fetchAttachment } = this.props;
        this.setState({
            modalIsLoading: true,
            showModalForm: true,
            modalTitle: `Output Record \u00A0\u00A0 Loading...`,
        })
        fetchAttachment(data.RechargingOutputRecordID).then(fetchedFiles=>{
            const generatedFiles = fetchedFiles ? fetchedFiles.map(file => ({
                key: file.Key,
                name: file.FileName,
                filePath: file.FilePath
            })) : [];

            const recordDataWithFiles = {
                ...data,
                GeneratedFiles: generatedFiles
            };
            this.setState({
                modalIsLoading: false,
                modalTitle: `Output Record \u00A0\u00A0 ${data.OutputRecordStatus.toUpperCase()}`,
                selectedRecordData: recordDataWithFiles,
            })
        })
    }

    handleCloseFormModal = () => {
        this.setState({ showModalForm: false})
    }

    onChangeExtractAlertMsg = (val, key) => {
        this.setState({
            extractAlertMsg: val
        });
    }

    render() {
        const { outputRecord, fetchOutputRecord, setColSearchStr, setColSort, addOutputRecordFilter, removeOutputRecordFilter }=this.props;
        const { showModalForm, modalTitle, selectedRecordData, isLoading, modalIsLoading } = this.state;
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdOutputRecordsRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdOutputRecordsRW])

        return (
            <>
                <div className="invoice-wrapper-container inventory-report-component">
                    <Translation
                        getOnlyText={true}
                        onChangeTranslation={this.onChangeExtractAlertMsg}
                        translationKey={"export_alert_message"}
                    />
                    <RequestHeaders headerTitle={this.state.headerTitle} />
                    <div className={`request-table data-table fit-width`}>
                        <DetailsDashboard
                            data={outputRecord.outputRecord.TableFilterData}
                            translation={""}
                            addAction={addOutputRecordFilter}
                            removeAction={removeOutputRecordFilter}
                            applyAction={this.applyFilter}
                            customClassName={"output-record"}
                            createNewAction={this.handleCreateNewAction}
                            isCreateButtonHidden={true}
                            isCustomColumns
                            viewSearchAction={this.displaySearchBox}
                            firstList={[]}
                            secondList={[]}
                            defaultList={[]}
                            saveAction={()=>{}}
                            extractAction={(e) => this.onClickExtract(e)}
                            isReadAndExtractOnly={isReadAndExtractOnly}
                            isReadAndWrite={isReadAndWrite}
                        >
                            {
                                isLoading
                                    ? this.loading()
                                    : outputRecord.outputRecord &&
                                    <TablePagination
                                        key={TABLE_PAGINATION_KEY.outputRecord}
                                        tablePaginationKey={TABLE_PAGINATION_KEY.outputRecord}
                                        uniqueKeyProp="RechargingOutputRecordId"
                                        classNameWrapper="overflow-auto"
                                        columns={outputRecord.outputRecord.Headers}
                                        pageList={outputRecord.outputRecord.Data}
                                        pages={outputRecord.outputRecord.Pagination}
                                        rowClickAction={this.handleRowClick}
                                        paginationAction={fetchOutputRecord}
                                        onColumnClick={setColSort}
                                        onColumnSearch={()=>{fetchOutputRecord(0)}}
                                        onColumnSearchChange={setColSearchStr}
                                        isColSearchShow={this.state.displaySearch}
                                        resizePage={this.resizePage}
                                        totalPage={outputRecord.outputRecord.Pagination.TotalEntries || 0}
                                        hideStatusIcon={false}
                                    />
                            }
                        </DetailsDashboard>
                        <ModalContainer
                            title={modalTitle}
                            show={showModalForm}
                            handleModal={this.handleCloseFormModal}
                            hideBtn={true}
                            customClass=""
                            noTranslation
                        >
                            <div>
                                <OutputRecordsInfo
                                    isLoading={modalIsLoading}
                                    recordData={selectedRecordData}
                                    isReadAndExtractOnly={isReadAndExtractOnly}
                                    isReadAndWrite={isReadAndWrite}
                                />
                            </div>
                        </ModalContainer>
                    </div>
                </div>
            </>
        );
    }
}
export default connect(
    state => {
        const { outputRecord, attachFile } = state
        return {
            outputRecord,
            attachFile
        }
    },
    dispatch =>
        bindActionCreators(Object.assign({}, OutputRecordAction), dispatch)
)(OutputRecordsDashboard);